import { render } from "./sekretaris.vue?vue&type=template&id=cb15585c"
import script from "./sekretaris.vue?vue&type=script&lang=js"
export * from "./sekretaris.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__